import React from "react";

import { Nav, Navbar, NavItem, Button } from "react-bootstrap";
import { links } from "../../content/header.yaml";
import Link from 'gatsby-link';
import navigate from '../../../navigation';
import logoNav from '../../../images/logo-nav.png'

class Header extends React.Component {

    render() {
        return (<Navbar collapseOnSelect>
            <Navbar.Header>
                <Navbar.Brand>
                    <Link to="/" >
                        <img src={logoNav} alt=""/>
                    </Link>
                </Navbar.Brand>
                <Navbar.Toggle />
            </Navbar.Header>
            <Navbar.Collapse>
                <Nav calss="nav-links">
                    {links.map((link, i) => {

                        if (link.isButton)
                        {
                            return <Button className="cb-button cb-button__header" href={link.url}>{link.copy}
                               </Button>
                        }
                        else
                        {
                            return <NavItem key={i} eventKey={i} onClick={()=> navigate(link.url, link.newTab)} target="_blank">
                                {link.copy}
                            </NavItem>
                        }
                    })}
                </Nav>
                {/*
                <Nav pullRight>
                    {isLoggedIn &&
                    <NavItem eventKey={1} onClick={this.logout}>
                        [Username]
                    </NavItem>
                    }
                    {!isLoggedIn &&
                    <NavItem eventKey={1} onClick={this.login}>
                        Login
                    </NavItem>
                    }
                </Nav>
                <Nav pullRight>
                    <DropdownButton
                        class="language-dropdown"
                        title={"Translations"}>
                        {
                            locales.map((locale, i) => {
                                return <MenuItem eventKey={i} className={`locale-dropdown-${locale}`}
                                                 onClick={() => i18n.changeLanguage(locale)}>{locale.toUpperCase()}</MenuItem>
                            })
                        }
                    </DropdownButton>
                </Nav>
                */}
            </Navbar.Collapse>
        </Navbar>);
    }
}


export default Header;